import './clients-list.component.js';
import './clients-list.controller.js';
import './_clients-list.styles.scss';
import './appointments';
import './update';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.clients-list', {
    url: '/clients-list?page&search',
    views: {
      '@': {
        component: 'inkClientsList'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      },
      search: {
        value: '',
        dynamic: true
      }
    },
    resolve: {
      $title: (() => 'Clients List.'),
      clients: function($stateParams, Association, Session) {
        let page = $stateParams.page;
        let search = $stateParams.search;
        let shopId = Session.activeState.association.shop.id;
        let appointmentWith;
        if (Session.activeState.role == 'artist') {
          appointmentWith = Session.collector.id;
        }
        return Association.getShopAssociations(
        shopId, Session.activeState.role, 'collector', page, search, appointmentWith)
        .then(function(response) {
          return response;
        });
      }
    },
    bindings: {
      $transition$: '<',
      clients: '<'
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    }
  });
});



// WEBPACK FOOTER //
// ./components/clients-list/index.js